@if (isOpen) {
  <div class="popup" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
      <span class="close-btn" (click)="closePopup()">×</span>
      <img [src]="imageSrc" alt="Popup Image" />
    </div>
  </div>
}
